import React from 'react';
import Conditional from '../../../common/conditional';

import classNames from './style.module.scss';
import russelsmithLogo from '../../../../assets/images/logo.png';

interface CustomCoverPageProps {
	reportTitle: string;
}

const CustomCoverPage: React.FC<CustomCoverPageProps> = ({ reportTitle }) => {
	return (
		<Conditional isVisible>
			<div className="container-fluid p-3">
				<div className={classNames.coverPage}>
					<div className={classNames.coverPageLogo}>
						<img src={russelsmithLogo} alt="Arridex" />
					</div>
					<div className={classNames.coverPageTitleBox}>
						<h2>{reportTitle}</h2>
					</div>
				</div>
			</div>
		</Conditional>
	);
};

export default CustomCoverPage;
